





























import { Component, Prop, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { abbreviateNumber } from '@/utils/currency';

@Component({
  components: {
    Typography
  }
})
export default class ListOfferOverview extends Vue {
  @Prop() interactingMembers!: number;
  @Prop() offerRedemptions!: number;
  @Prop() activeOffers!: number;
  @Prop() offersSaved!: number;
  @Prop() offerImpressions!: number;

  isEndOfScroll = false;

  get performances() {
    return [
      {
        title: 'Members Who Interacted with Your Offers',
        value: abbreviateNumber(this.interactingMembers),
        description:
          'Total number of engaged members who have opened, saved or redeemed Offers.'
      },
      {
        title: 'Offer Redemptions',
        value: abbreviateNumber(this.offerRedemptions),
        description: 'Total number of Offers successfully redeemed by members.'
      },
      {
        title: 'Active Offers',
        value: abbreviateNumber(this.activeOffers),
        description: 'Number of Offers currently active for your business.'
      },
      {
        title: 'Offers Saved',
        value: abbreviateNumber(this.offersSaved),
        description:
          'Total number of times Offers have been saved by members for future use.'
      },
      {
        title: 'Offer Impressions',
        value: abbreviateNumber(this.offerImpressions),
        description:
          'Total number of times your Offers have been displayed to members within Twism. <a target="_blank" href="https://support.twism.com/hc/en-us/articles/29210709420429-What-are-Offer-Impressions">Learn more</a>'
      }
    ];
  }

  mounted() {
    const scrollContainer = this.$refs.scrollContainer as HTMLElement;
    scrollContainer.addEventListener('scroll', this.checkIfEndOfScroll);
  }

  beforeDestroy() {
    const scrollContainer = this.$refs.scrollContainer as HTMLElement;
    scrollContainer.removeEventListener('scroll', this.checkIfEndOfScroll);
  }
  checkIfEndOfScroll() {
    const scrollContainer = this.$refs.scrollContainer as HTMLElement;
    const scrollRightPosition =
      scrollContainer.scrollLeft + scrollContainer.clientWidth;

    const lastItem = scrollContainer.lastElementChild as HTMLElement;
    const lastItemLeftEdge = lastItem.offsetLeft;
    const lastItemHalfWidth = lastItem.clientWidth * 0.5;

    this.isEndOfScroll =
      scrollRightPosition >= lastItemLeftEdge + lastItemHalfWidth;
  }
}
